import { AccountStatusLabel, OrderStatusLabel, OfferOrderStatusLabel, TransferStatusLabel } from 'src/models';
import { Color } from 'src/styles';

export const getTransferStatusTagColor = (value: TransferStatusLabel): { background: string; color: string } => {
  let background;
  let color;

  switch (value) {
    case TransferStatusLabel.PENDING:
      background = Color.Gray3;
      color = Color.Gray7;
      break;

    case TransferStatusLabel.REJECTED:
      background = Color.Red2;
      color = Color.Red7;
      break;

    case TransferStatusLabel.COMPLETED:
      background = Color.Green2;
      color = Color.Green7;
      break;

    case TransferStatusLabel.CANCELLED:
      background = Color.Orange2;
      color = Color.Orange7;
      break;

    default:
      background = Color.Brand2;
      color = Color.Brand7;
  }

  return { background, color };
};

export const getOrderStatusTagColor = (value: OrderStatusLabel): { background: string; color: string } => {
  let background;
  let color;

  switch (value) {
    case OrderStatusLabel.REJECTED:
      background = Color.Red2;
      color = Color.Red7;
      break;

    case OrderStatusLabel.COMPLETED:
      background = Color.Green2;
      color = Color.Green7;
      break;

    case OrderStatusLabel.CANCELLED:
      background = Color.Orange2;
      color = Color.Orange7;
      break;

    default:
      background = Color.Gray4;
      color = Color.Gray7;
  }

  return { background, color };
};

export const getOfferOrderStatusTagColor = (value: OfferOrderStatusLabel): { background: string; color: string } => {
  switch (value) {
    case OfferOrderStatusLabel.PendingFunds:
      return {
        background: Color.Gray3,
        color: Color.Gray7,
      };
    case OfferOrderStatusLabel.PendingOfferClose:
      return {
        background: Color.Orange1,
        color: Color.Gray8,
      };
    case OfferOrderStatusLabel.PendingAction:
      return {
        background: Color.Brand1,
        color: Color.Brand7,
      };
    case OfferOrderStatusLabel.Approved:
      return { background: Color.Brand2, color: Color.Brand7 };
    case OfferOrderStatusLabel.Complete:
      return { background: Color.Green2, color: Color.Green7 };
    case OfferOrderStatusLabel.PendingFirmCancellation:
      return {
        background: Color.Orange1,
        color: Color.Orange7,
      };
    case OfferOrderStatusLabel.Cancelled:
      return { background: Color.Orange2, color: Color.Orange7 };
    case OfferOrderStatusLabel.Rejected:
      return { background: Color.Red2, color: Color.Red7 };
    case OfferOrderStatusLabel.Deleted:
      return { background: Color.Red2, color: Color.Red8 };
  }
};

export const getAccountStatusTagColor = (value: AccountStatusLabel): { background: string; color: string } => {
  let backgroundColor;
  let textColor;

  switch (value) {
    case AccountStatusLabel.Active:
      backgroundColor = Color.Green7;
      textColor = Color.Green1;
      break;
    case AccountStatusLabel.Rejected:
      backgroundColor = Color.Red6;
      textColor = Color.Gray1;
      break;
    default:
      backgroundColor = Color.Orange6;
      textColor = Color.Orange1;
      break;
  }

  return { background: backgroundColor, color: textColor };
};
